document.addEventListener("DOMContentLoaded", () => {
  const itemsPerPage = 6;
  const grid = document.getElementById("SubCollectionsGrid");
  const pagination = document.getElementById("SubCollectionPagination");

  const prevIcon = `<svg class="icon-pagination-bottom" viewBox="0 0 256 256" role="img" aria-labelledby="iconTitle"><title id="iconTitle">Previous</title><path d="M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" fill="#1C2B4A"/></svg>`;
  const nextIcon = `<svg class="icon-pagination-bottom" viewBox="0 0 256 256" role="img" aria-labelledby="iconTitle"><title id="iconTitle">Next</title><path d="M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" fill="#1C2B4A"/></svg>`;

  if (!grid || !pagination) return;

  const items = Array.from(grid.querySelectorAll("li[data-index]"));
  const totalPages = Math.ceil(items.length / itemsPerPage);
  let currentPage = 1;

  const showPage = (page) => {
    currentPage = page;
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    items.forEach((item, i) => {
      item.style.display = (i >= start && i < end) ? "block" : "none";
    });

    renderPagination();
  };

  const renderPagination = () => {
    if (totalPages <= 1) {
      pagination.innerHTML = "";
      return;
    }

    const pageSpans = [];

    if (currentPage > 1) {
      pageSpans.push(
        `<span role="button" tabindex="0" data-page="${currentPage - 1}" class="pagination__item">${prevIcon}</span>`
      );
    }

    for (let i = 1; i <= totalPages; i++) {
      pageSpans.push(
        `<span role="button" tabindex="0" data-page="${i}" class="pagination__item${i === currentPage ? ' pagination__item--current' : ''}">${i}</span>`
      );
    }

    if (currentPage < totalPages) {
      pageSpans.push(
        `<span role="button" tabindex="0" data-page="${currentPage + 1}" class="pagination__item">${nextIcon}</span>`
      );
    }

    pagination.innerHTML = `<div class="pagination__list">${pageSpans.join('')}</div>`;
    pagination.querySelectorAll('[data-page]').forEach(el => {
      el.addEventListener('click', () => {
        showPage(parseInt(el.dataset.page));
      });
      el.addEventListener('keypress', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          showPage(parseInt(el.dataset.page));
        }
      });
    });
  };

  showPage(currentPage);
});
